import * as React from 'react';
import GridContainer from "../GenericComponents/Grids/GridContainer";
import {createBreadCrumbBasedOnPage} from "../../Utils/HelperFunctions";
import * as actionTypes from "../../store/action";
import {connect} from "react-redux";

interface TransmissionOwnerInfoProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
}

interface TransmissionOwnerInfoState {
}

class TransmissionOwnerInfo extends React.Component<TransmissionOwnerInfoProps,TransmissionOwnerInfoState> {

    constructor(props: TransmissionOwnerInfoProps) {
        super(props);
    }

    componentDidMount(): void {
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));
    }

    render() {
        return (
            <GridContainer
                getGridDataUrl={'/api/auth/viewGridData/transmissionOwner'}
                gridPaginated={true}
                formEditing={true}
                exportLink={'viewGridData/transmissionOwner'}
                gridTitle={'Facility/Transmission Owners'}
                gridId={'transmissionOwnersGrid'}
                showUtilityColumns={true}
                addRecordUrl={'/api/auth/saveGridRecord/transmissionOwner'}
                editRecordUrl={'/api/auth/editGridRecord/transmissionOwner'}
                deleteRecordUrl={'/api/auth/removeGridRecord/transmissionOwner'}
                typeForSuperClass={'transmissionOwner'}
            />
        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(null, mapDispatchToProps)(TransmissionOwnerInfo);